import type { MaterializedMenuProduct } from '@iheartjane/data-access';
import { Flex, Tag } from '@iheartjane/reefer';
import type { PriceId } from '@iheartjane/types';

import { useKioskSpacing } from '@jane/kiosk/hooks';
import { customLineageLabel, getCategoryTagColor } from '@jane/kiosk/util';
import type { AlgoliaProduct } from '@jane/search/data-access';
import { formatPotency, getPotencyInfo } from '@jane/shared-ecomm/util';
import type { Store } from '@jane/shared/types';

export type ProductTagsProps = {
  product: AlgoliaProduct | MaterializedMenuProduct;
  selectedWeight: PriceId;
  store: Store;
};

export const ProductTags = ({
  store,
  product,
  selectedWeight,
}: ProductTagsProps) => {
  const { getKioskSpacing } = useKioskSpacing();

  const {
    percentCbd,
    percentTac = 0,
    percentThc = 0,
    percentThca = 0,
  } = getPotencyInfo(product, selectedWeight) || {};
  const tac = formatPotency(percentTac) || 0;
  const thc = formatPotency(percentThc) || 0;
  const thca = formatPotency(percentThca) || 0;
  const cbd = formatPotency(percentCbd) || 0;

  return !!product.category || thc || cbd ? (
    <Flex
      flexDirection="row"
      mb={getKioskSpacing(16, 8)}
      flexWrap="wrap"
      gap={8}
    >
      {!!product.category && product.category !== 'cbd' && (
        <Tag
          label={customLineageLabel({ store, lineage: product.category })}
          background={getCategoryTagColor(product.category)}
          color="grays-white"
        />
      )}
      {percentTac > 0 && (
        <Tag label={`TAC ${tac}%`} background="grays-mid" color="grays-white" />
      )}
      {percentThc > 0 && (
        <Tag label={`THC ${thc}%`} background="grays-mid" color="grays-white" />
      )}
      {!!percentCbd && percentCbd > 0 && (
        <Tag label={`CBD ${cbd}%`} background="grays-mid" color="grays-white" />
      )}
      {!!percentCbd && percentCbd === 0 && product.category === 'cbd' && (
        <Tag label="CBD" background="grays-mid" color="grays-white" />
      )}
      {percentThca > 0 && (
        <Tag
          label={`THCa ${thca}%`}
          background="grays-mid"
          color="grays-white"
        />
      )}
    </Flex>
  ) : null;
};
